(function (angular, getComputedStyle, innerHeight, innerWidth, addEventListener, removeEventListener, ToyotaConsts) {
  "use strict";

  var ACCORDION_LABEL_SET_DELAY_MS = 500;
  var TOTAL_DURATION_MULTIPLIER = 1.3;
  var PULL_END_Y_FRACTION_VIEWPORT_HEIGHT = 0.6;
  var MAX_LAYOUT_SOLVE_ATTEMPTS = 3;
  var OPACITY_DELAY_FUDGE_MS = 100;

  angular.module("Toyota.Directives").directive("tyFancyAccordion", [
    "$rootScope",
    "InfoService",
    "CssMediaWatcher",
    "CustomEasings",
    "$analytics",
    "DebugLogger",
    function ($rootScope, InfoService, CssMediaWatcher, CustomEasings, $analytics, DebugLogger) {
      return {
        restrict: "A",
        scope: true,
        link: function ($scope, $element, $attrs) {
          var logDebugInfo = false;

          // TODO: Yank as much code as possible out of 'link' and into a separate module
          // eslint-disable-next-line consistent-this
          var self = {};
          self.$label = angular.element("#" + $attrs.tyFancyAccordionUniqueLabelId);
          self.$elAboveFixedHeader = angular.element(".navbar-default");
          self.$next = null;
          self.$prev = null;
          self.isOpen = false;
          self.$controls = $element.find(".ty-fancy-accordion__controls");
          self.controlsDistanceFromPageTop = null;
          self.controlsDistanceFromPrevBottom = null;
          self.controlsDistanceFromContentTop = null;
          self.controlsDistanceFromContentBottom = null;
          self.$content = $element.find(".ty-fancy-accordion__container");
          self.$toggleButton = $element.find(".ty-fancy-accordion-button");
          self.baseDuration = 1100;
          self.totalDuration = self.baseDuration * TOTAL_DURATION_MULTIPLIER;
          self.pullEndYpercentViewportHeight = PULL_END_Y_FRACTION_VIEWPORT_HEIGHT;
          var navBarMetrics = InfoService.get(ToyotaConsts.InfoKeys.SecondaryNavMetrics);
          self.navBarHeight = navBarMetrics ? navBarMetrics.navbarHeight || 0 : 0;

          self.track = function (isOpen) {
            var props = {
              event: "gaClick",
              eventCategory: "Accordion",
              eventAction: self.accordionLabel(isOpen),
              eventLabel: isOpen ? "View" : "Hide",
            };

            $analytics.eventTrack("gaClick", props);
          };

          self.isTopLevelLayoutElement = function (index, el) {
            var $el = angular.element(el);
            if ($el.filter('script, noscript, .ty-secondary-nav[style*="fixed"]').length) {
              return false;
            }

            var styles = getComputedStyle(el);

            return !(styles.position === "fixed" || styles.position === "absolute" || styles.display === "none");
          };

          self.getPrevOne = function () {
            return $element.prevAll().filter(self.isTopLevelLayoutElement).first();
          };

          self.getNextOne = function () {
            return $element.nextAll().filter(self.isTopLevelLayoutElement).first();
          };

          self.init = function () {
            angular.element(window).on("resize", function () {
              self.updateScrollTopDependentControlsPositioningClasses();
            });

            CssMediaWatcher({
              $el: $element,
              pseudoEl: "before",
              mediaProperty: "viewportWidth",
              mediaRegexes: {
                mobile: "^mobile$",
                desktop: "^desktop$",
              },
            }).on("didInitOrChange", function (e, cssMedia) {
              if (cssMedia.viewportWidth.is.desktop) {
                self.controlsDistanceFromPageTop = 16;
                self.controlsDistanceFromPrevBottom = 16;
                self.controlsDistanceFromContentTop = 16;
                self.controlsDistanceFromContentBottom = 16;
              } else {
                self.controlsDistanceFromPageTop = 16;
                self.controlsDistanceFromPrevBottom = 16;
                self.controlsDistanceFromContentTop = 16;
                self.controlsDistanceFromContentBottom = 16;
              }
            });

            self.enableToggleButton();
            self.setAccordionLabel(false);
          };

          self.accordionLabel = function (isOpen) {
            return !isOpen ? $attrs.tyFancyAccordionLabel : $attrs.tyFancyAccordionExpandedLabel;
          };

          self.setAccordionLabel = function (isOpen) {
            setTimeout(function () {
              self.$label.html(self.accordionLabel(isOpen));
            }, ACCORDION_LABEL_SET_DELAY_MS);
          };

          self.enableToggleButton = function () {
            self.$toggleButton.on("click", function () {
              self.toggleAccordion();
            });
          };

          self.disableToggleButton = function () {
            self.$toggleButton.off("click");
          };

          self.toggleAccordion = function () {
            if (!self.isOpen) {
              self.openAccordion();
            } else {
              self.closeAccordion();
              $rootScope.$broadcast("accordion-close", self.$controls);
            }

            self.isOpen = !self.isOpen;
          };

          self.debugInfo = function () {
            if (!logDebugInfo) {
              return;
            }

            DebugLogger.log.apply(this, arguments);
          };

          self.solveAllVisiblePrevOrNext = function (prevOrNext, topLimit, bottomLimit) {
            var isNext = prevOrNext === "next";
            var $allVisible = isNext
              ? $element.nextAll().filter(self.isTopLevelLayoutElement)
              : Array.prototype.reverse.call($element.prevAll().filter(self.isTopLevelLayoutElement));

            /* eslint-disable no-param-reassign */
            topLimit = typeof topLimit !== "undefined" ? topLimit : 0;
            bottomLimit = typeof bottomLimit !== "undefined" ? bottomLimit : innerHeight;
            /* eslint-enable no-param-reassign */

            $allVisible = $allVisible.filter(function (i, el) {
              var elRect = el.getBoundingClientRect();
              return (
                (elRect.top > topLimit && elRect.top <= bottomLimit) || // top edge in viewport
                (elRect.bottom > topLimit && elRect.bottom <= bottomLimit) || // bottom edge in viewport
                (elRect.top < topLimit && elRect.bottom > bottomLimit) // top edge above viewport top + bottom edge below viewport bottom
              );
            });
            self.debugInfo("    solveAllVisiblePrevOrNext: ", prevOrNext, $allVisible.toArray());
            self.debugInfo("      topLimit: ", topLimit, "bottomLimit:", bottomLimit);
            self.debugInfo("      $" + prevOrNext + ".length ===", $allVisible.length);

            if (isNext) {
              self.$next = $allVisible;
            } else {
              self.$prev = $allVisible;
            }
          };

          self.solvePrevAndNext = function (topLimit, bottomLimit) {
            self.solveAllVisiblePrevOrNext("prev", topLimit, bottomLimit);
            self.solveAllVisiblePrevOrNext("next", topLimit, bottomLimit);
          };

          self.getBoundingClientRectAll = function ($els) {
            return self.boundingBoxOfUnionOfRects(self.getBoundingClientRects($els));
          };

          self.getBoundingClientRects = function ($els) {
            if (!$els.length) {
              throw new Error("Can't get bounding union for empty $els");
            }

            var rects = [];

            $els.each(function (index, el) {
              var rect = el.getBoundingClientRect();
              rects.push(rect);
            });

            return rects;
          };

          self.boundingBoxOfUnionOfRects = function (rects) {
            if (!rects.length) {
              throw new Error("Can't get union for empty array of rects");
            }

            var boundingBox = {
              top: rects[0].top,
              left: rects[0].left,
              right: rects[0].right,
              bottom: rects[0].bottom,
            };

            if (rects.length === 1) {
              return boundingBox;
            }

            for (var i = 1; i < rects.length; i++) {
              var rect = rects[i];
              boundingBox = {
                top: rect.top < boundingBox.top ? rect.top : boundingBox.top,
                left: rect.left < boundingBox.left ? rect.left : boundingBox.left,
                right: rect.right > boundingBox.right ? rect.right : boundingBox.right,
                bottom: rect.bottom > boundingBox.bottom ? rect.bottom : boundingBox.bottom,
              };
            }

            return boundingBox;
          };

          self.getHeightOfElAboveFixedHeader = function () {
            return self.$elAboveFixedHeader.length ? self.$elAboveFixedHeader.height() : 0;
          };

          self.openAccordion = function () {
            self.debugInfo("  Selecting visible elements before and after the accordion into $prev and $next arrays");
            self.solvePrevAndNext();

            var startPrevRects = self.$prev.length ? self.getBoundingClientRects(self.$prev) : null;
            var startNextRects = self.$next.length ? self.getBoundingClientRects(self.$next) : null;
            var startControlsRect = self.$controls[0].getBoundingClientRect();

            document.body.style.overflowAnchor = "none";

            // Measure what the $content height would be if it were open
            self.$content.css({ height: "auto", visibility: "hidden" });
            var startContentRect = self.$content[0].getBoundingClientRect();
            var contentHeight = startContentRect.bottom - startContentRect.top;
            self.$content.css({ height: "", visibility: "" });
            self.debugInfo(
              "openAccordion (only one case) -- pushing next slice out by up to contentHeight = ",
              contentHeight
            );

            self.disableToggleButton();
            self.freezeScrollingJustForAnimation();
            self.$content.addClass("is-open");
            self.$controls.addClass("is-open");
            self.$toggleButton.addClass("is-open");
            self.startUpdatingControlsPositioningOnScroll();

            self.debugInfo("  Triggering animations");
            self.setAccordionLabel(true);
            $.when(
              self.animateContentFade("fade-in"),
              self.moveControlsTo(startControlsRect, startContentRect.top + self.controlsDistanceFromContentTop),
              startPrevRects ? self.pushPrevFrom(startPrevRects, startContentRect.top, 0) : $.when(), // $.when() means "resolved empty promise"
              startNextRects ? self.pushNextFrom(startNextRects, startContentRect.top, contentHeight) : $.when()
            ).done(didAnimate);

            function didAnimate() {
              self.enableToggleButton();
              self.unfreezeScrollingJustForAnimation();
              self.updateScrollTopDependentControlsPositioningClasses();
              document.body.style.overflowAnchor = "";
              self.track(true);
            }
          };

          /*
           * Good enough for most cases except someone physically dragging the
           * scrollbar -- which is actually quite challenging to do in 0.7sec :)
           *
           * Didn't use overflow: hidden because of the layout jerking
           *
           */
          self.freezeScrollingJustForAnimation = function () {
            angular
              .element("body")
              .on(
                "mousewheel.freezeScrolling DOMMouseScroll.freezeScrolling keydown.freezeScrolling touchmove.freezeScrolling",
                function () {
                  return false;
                }
              );
          };

          self.unfreezeScrollingJustForAnimation = function () {
            angular
              .element("body")
              .off(
                "mousewheel.freezeScrolling DOMMouseScroll.freezeScrolling keydown.freezeScrolling touchmove.freezeScrolling"
              );
          };

          self.closeAccordion = function () {
            var viewportHeight = innerHeight;

            var $prevOne = self.getPrevOne();
            var $nextOne = self.getNextOne();

            var prevOnScreen, nextOnScreen, startContentRect, topLimit, bottomLimit;

            var startPrevOneRect, startNextOneRect, startControlsRect, prevBottom, nextTop, contentTop, controlsHeight;

            var startPrevRects, startNextRects, startPrevRect, startNextRect, prevHeight, nextHeight;

            var meetInTheMiddleY, scrollFocalPointFinalTopInViewport, $elScrollFocalPoint;

            // The exact transition we use depends on which content edge is on screen, if any
            prevOnScreen = self.isOnScreen($prevOne);
            nextOnScreen = self.isOnScreen($nextOne);

            startContentRect = self.$content[0].getBoundingClientRect();

            var limitsChangedSinceLastSolution = true;
            var solveAttempt = 1;

            /*
             * What is the minimum we can include in $prevOne and $nextOne? (If we include everything, things will get sluggish.)
             * 1. Start with the union of the viewport and the starting content rect
             * 2. Make an initial estimate:
             *    - If prevOnScreen, then $next will be pulled up, so extend the bottom of the inclusion rect by one viewport height (makes $next larger)
             *    - If nextOnScreen, then $prev will be pulled down, so extend the top of the inclusion rect by one viewport height (makes $prev larger)
             */

            topLimit = Math.min(0, startContentRect.top);
            bottomLimit = Math.max(viewportHeight, startContentRect.bottom);

            if (prevOnScreen) {
              self.debugInfo("closeAccordion -- case prevOnScreen");
              bottomLimit += viewportHeight;
            } else if (nextOnScreen) {
              self.debugInfo("closeAccordion -- case nextOnScreen");
              topLimit -= viewportHeight;
              bottomLimit += viewportHeight;
            } else {
              self.debugInfo("closeAccordion -- case neither prevOnScreen nor nextOnScreen");
              topLimit -= viewportHeight;
              bottomLimit += viewportHeight;
            }

            // Initial plan for the animation -- set meetInTheMiddleY based on unwrapped prevBottom / nextTop

            // if $prevOne is visible, $prevOne doesn't move UNLESS not enough content in $nextOne to fill bottom of viewport
            if (prevOnScreen) {
              startPrevOneRect = $prevOne[0].getBoundingClientRect();
              prevBottom = startPrevOneRect.bottom;
              self.debugInfo(
                "  Planning to pull both slices (mainly just $nextOne) toward meetInTheMiddleY = prevBottom =",
                prevBottom
              );
              meetInTheMiddleY = prevBottom;
              $elScrollFocalPoint = $prevOne;
              scrollFocalPointFinalTopInViewport = startPrevOneRect.top;

              // if $nextOne is visible, $nextOne doesn't move UNLESS not enough content in $prevOne to fill top of viewport
            } else if (nextOnScreen) {
              startNextOneRect = $nextOne[0].getBoundingClientRect();
              nextTop = startNextOneRect.top;
              self.debugInfo(
                "  Planning to pull both slices (mainly just $prevOne) toward meetInTheMiddleY = nextTop =",
                nextTop
              );
              meetInTheMiddleY = nextTop;
              $elScrollFocalPoint = $nextOne;
              scrollFocalPointFinalTopInViewport = startNextOneRect.top;

              // if $neither are visible, both move, with adjustments so $prevOne + $nextOne can both fill the viewport where possible.
            } else {
              self.debugInfo(
                "  Planning to pull both slices toward meetInTheMiddleY =",
                self.pullEndYpercentViewportHeight,
                " * viewportHeight =",
                meetInTheMiddleY
              );
              meetInTheMiddleY = viewportHeight * self.pullEndYpercentViewportHeight;
              $elScrollFocalPoint = $nextOne;
              scrollFocalPointFinalTopInViewport = meetInTheMiddleY;
            }

            self.debugInfo(
              "    Will bring top of",
              $elScrollFocalPoint,
              "to position",
              scrollFocalPointFinalTopInViewport
            );

            /*
             * Now, solve for $prev and $next and measure them, so we can check if the animation will
             * "fill the viewport", especially important at the ends of the document.
             *
             * We may need to adjust meetInTheMiddleY to avoid showing gray space at the ends of the document:
             *   - If adjustment is NOT required, then we're all done, proceed to execute animation.
             *   - If adjustment IS required, we revise meetInTheMiddleY and topLimit/bottomLimit. As the solution
             *     limits have changed, this loop will happen again.
             */

            var selfRect = $element[0].getBoundingClientRect();

            while (limitsChangedSinceLastSolution) {
              // Solve and measure $prev and $next
              self.debugInfo(
                "  Solve $prev and $next attempt #",
                solveAttempt,
                "(topLimit=",
                topLimit,
                ", bottomLimit=",
                bottomLimit,
                ")"
              );
              self.solvePrevAndNext(topLimit, bottomLimit);
              limitsChangedSinceLastSolution = false;

              if (self.$prev.length) {
                startPrevRects = self.getBoundingClientRects(self.$prev);
                startPrevRect = self.boundingBoxOfUnionOfRects(startPrevRects);
              } else {
                startPrevRects = [];
                startPrevRect = { top: selfRect.top, left: selfRect.left, right: selfRect.right, bottom: selfRect.top };
              }

              prevHeight = startPrevRect.bottom - startPrevRect.top;

              if (self.$next.length) {
                startNextRects = self.getBoundingClientRects(self.$next);
                startNextRect = self.boundingBoxOfUnionOfRects(startNextRects);
              } else {
                startNextRects = [];
                startNextRect = {
                  top: selfRect.bottom,
                  left: selfRect.left,
                  right: selfRect.right,
                  bottom: selfRect.bottom,
                };
              }

              nextHeight = startNextRect.bottom - startNextRect.top;

              /*
               * Do we need to move meetInTheMiddleY so that content still fills the viewport?
               * (If yes, we'll need to re-wrap $prevOne and $nextOne.)
               */

              var oldMeetInTheMiddleY = meetInTheMiddleY;
              var oldTopLimit = topLimit;
              var oldBottomLimit = bottomLimit;

              var prevTallEnoughToFillTopOfViewport = prevHeight >= meetInTheMiddleY;
              var nextTallEnoughToFillBottomOfViewport = nextHeight >= viewportHeight - meetInTheMiddleY;
              var documentTopInViewport =
                document.body.getBoundingClientRect().top + self.getHeightOfElAboveFixedHeader();
              var documentBottomInViewport =
                documentTopInViewport + angular.element(document).height() - self.getHeightOfElAboveFixedHeader();

              if (!prevTallEnoughToFillTopOfViewport) {
                meetInTheMiddleY = prevHeight;
                topLimit -= viewportHeight;
                topLimit = Math.max(Math.min(oldTopLimit, topLimit), documentTopInViewport); // this limit should only move up / clamp at document top
                self.debugInfo(
                  "    $prev not tall enough to fill viewport top, we're off by",
                  oldMeetInTheMiddleY - meetInTheMiddleY
                );
                self.debugInfo(
                  "      Moving meetInTheMiddleY from",
                  oldMeetInTheMiddleY,
                  "up to",
                  meetInTheMiddleY,
                  " and extending topLimit upwards from",
                  oldTopLimit,
                  "to",
                  topLimit
                );
                limitsChangedSinceLastSolution = true;
              } else if (!nextTallEnoughToFillBottomOfViewport) {
                meetInTheMiddleY = viewportHeight - nextHeight;
                bottomLimit += viewportHeight;
                bottomLimit = Math.min(Math.max(oldBottomLimit, bottomLimit), documentBottomInViewport); // this limit should only move down / clamp at document bottom
                self.debugInfo(
                  "    $next not tall enough to fill viewport bottom, we're off by",
                  oldMeetInTheMiddleY - meetInTheMiddleY
                );
                self.debugInfo(
                  "      Moving meetInTheMiddleY from",
                  oldMeetInTheMiddleY,
                  "down to",
                  meetInTheMiddleY,
                  " and extending bottomLimit downwards from",
                  oldBottomLimit,
                  "to",
                  bottomLimit
                );
                limitsChangedSinceLastSolution = true;
              }

              // That's it, we're including the whole damn document, quit iterating
              if (oldTopLimit === topLimit && oldBottomLimit === bottomLimit) {
                self.debugInfo(String("    STOPPING at solution attempt #" + solveAttempt));
                self.debugInfo(
                  "    We've included as much as we need to into $prev / $next -- everything from topLimit =",
                  topLimit,
                  "down to bottomLimit =",
                  bottomLimit,
                  "(that's",
                  bottomLimit - topLimit,
                  "px of a",
                  angular.element(document).height(),
                  "px tall document)"
                );
                break;
              }

              /*
               * This shouldn't even happen, but in case it does, just go ahead with
               * whatever transition we have settled on
               */
              if (solveAttempt >= MAX_LAYOUT_SOLVE_ATTEMPTS) {
                self.debugInfo("    Giving up after 3 solution attempts. Too much!");
                break;
              }

              if (limitsChangedSinceLastSolution) {
                solveAttempt++;
              }
            }

            startControlsRect = self.$controls[0].getBoundingClientRect();
            contentTop = startContentRect.top;
            controlsHeight = startControlsRect.bottom - startControlsRect.top;

            self.disableToggleButton();
            self.freezeScrollingJustForAnimation();
            self.fixElAt(self.$content, contentTop);
            self.stopUpdatingControlsPositioningOnScroll();
            self.$controls.removeClass("is-open");
            self.$toggleButton.removeClass("is-open");

            self.debugInfo("  Triggering animations");
            self.setAccordionLabel(false);
            $.when(
              self.animateContentFade("fade-out"),
              self.pullPrevTo(startPrevRects, meetInTheMiddleY),
              self.pullNextTo(startNextRects, meetInTheMiddleY),
              self.moveControlsTo(
                startControlsRect,
                meetInTheMiddleY - controlsHeight - self.controlsDistanceFromPrevBottom
              )
            ).done(function () {
              var heightOfElAboveFixedHeader = self.getHeightOfElAboveFixedHeader();
              if (angular.element(window).scrollTop() > heightOfElAboveFixedHeader) {
                // Why Math.max(..., 0.01)? Never scroll exactly to the top or iOS will present the URL bar
                angular
                  .element(window)
                  .scrollTop(
                    Math.max(
                      $elScrollFocalPoint.offset().top - scrollFocalPointFinalTopInViewport,
                      heightOfElAboveFixedHeader
                    )
                  );
              }

              didAnimate();
            });

            function didAnimate() {
              self.enableToggleButton();
              self.$content.removeClass("is-open");
              self.unfixEl(self.$content);
              self.unfreezeScrollingJustForAnimation();
              self.track(false);
            }
          };

          self.fixElAt = function ($el, top) {
            $el.addClass("is-fixed");
            $el.css("top", top);
          };

          self.unfixEl = function ($el) {
            $el.removeClass("is-fixed");
            $el.css("top", "");
          };

          self.pushPrevFrom = function (startRects, startingBottomInPx, byAtLeastHowMuch) {
            self.debugInfo("    pushPrevFrom");
            if (!startRects.length) {
              self.debugInfo("    pushPrevFrom passed empty startRects, nothing to do here");
              return $.Deferred().resolve().promise();
            }

            var startPrevRect = self.boundingBoxOfUnionOfRects(startRects);
            var prevHeight = startPrevRect.bottom - startPrevRect.top;
            self.$prev.data("animateDebugTag", "prev");
            return self.animateAll(
              self.$prev,
              startRects,
              startingBottomInPx - prevHeight,
              Math.max(-prevHeight, startingBottomInPx - prevHeight + byAtLeastHowMuch),
              "ty-fancy-accordion-prev-next-is-fixed"
            );
          };

          self.pushNextFrom = function (startRects, startingTopInPx, byAtLeastHowMuch) {
            self.debugInfo("    pushNextFrom");
            if (!startRects.length) {
              self.debugInfo("    pushNextFrom passed empty startRects, nothing to do here");
              return $.Deferred().resolve().promise();
            }

            self.$next.data("animateDebugTag", "next");
            return self.animateAll(
              self.$next,
              startRects,
              startingTopInPx,
              Math.min(innerHeight, startingTopInPx + byAtLeastHowMuch),
              "ty-fancy-accordion-prev-next-is-fixed"
            );
          };

          self.pullPrevTo = function (startRects, endingBottomInPx) {
            self.debugInfo("    pullPrevTo");
            if (!startRects.length) {
              self.debugInfo("    pullPrevTo passed empty startRects, nothing to do here");
              return $.Deferred().resolve().promise();
            }

            var startPrevRect = self.boundingBoxOfUnionOfRects(startRects);
            var prevHeight = startPrevRect.bottom - startPrevRect.top;
            self.$prev.data("animateDebugTag", "prev");
            return self.animateAll(
              self.$prev,
              startRects,
              Math.max(startPrevRect.top, -prevHeight),
              endingBottomInPx - prevHeight,
              "ty-fancy-accordion-prev-next-is-fixed"
            );
          };

          self.pullNextTo = function (startRects, endingTopInPx) {
            self.debugInfo("    pullNextTo");
            if (!startRects.length) {
              self.debugInfo("    pullNextTo passed empty startRects, nothing to do here");
              return $.Deferred().resolve().promise();
            }

            var startRect = self.boundingBoxOfUnionOfRects(startRects);
            self.$next.data("animateDebugTag", "next");
            return self.animateAll(
              self.$next,
              startRects,
              Math.min(startRect.top, innerHeight),
              endingTopInPx,
              "ty-fancy-accordion-prev-next-is-fixed"
            );
          };

          self.moveControlsTo = function (startRect, endingTopInPx) {
            self.debugInfo("    moveControlsTo");
            self.$controls.data("animateDebugTag", "controls");
            return self.animate(self.$controls, startRect.top, endingTopInPx, "is-fixed");
          };

          self.animateAll = function ($els, startingRects, startingTopInPx, endingTopInPx, cssClassWhileAnimating) {
            var animatePromises = [];
            var boundingRect = self.boundingBoxOfUnionOfRects(startingRects);
            $els.each(function (i) {
              var $el = angular.element(this);
              var rect = startingRects[i];
              var topOffset = rect.top - boundingRect.top;
              var placeholderHeight = rect.bottom - rect.top;
              var startingTopOneInPx = startingTopInPx + topOffset;
              var endingTopOneInPx = endingTopInPx + topOffset;
              $el.data("animateDebugTagNum", i);
              animatePromises.push(
                self.animate($el, startingTopOneInPx, endingTopOneInPx, cssClassWhileAnimating, placeholderHeight)
              );
            });
            return $.when.apply($, animatePromises);
          };

          self.animate = function ($el, startingTopInPx, endingTopInPx, cssClassWhileAnimating, placeholderHeight) {
            self.debugInfo(
              "      animate:",
              ($el.data("animateDebugTag") || "") +
                (typeof $el.data("animateDebugTagNum") !== "undefined"
                  ? "[" + $el.data("animateDebugTagNum") + "] ==="
                  : ""),
              $el[0],
              "from",
              startingTopInPx,
              "->",
              endingTopInPx
            );

            var deferred = $.Deferred();
            var $placeholder = null;

            if (placeholderHeight) {
              $placeholder = angular.element("<div></div>").css({
                height: placeholderHeight,
              });
              $el.before($placeholder);
            }

            CustomEasings.ensureAvailableForAnimate("fancyAccordionEasing", CustomEasings.curves.EASE_IN_OUT_EXPO, {
              base: 3,
              exponent: 9,
            });

            $el.addClass(cssClassWhileAnimating);
            $el.css("top", startingTopInPx + "px");
            $el.animate(
              { top: endingTopInPx },
              {
                duration: self.baseDuration,
                easing: "fancyAccordionEasing",
                complete: function () {
                  $el.removeClass(cssClassWhileAnimating);
                  $el.css("top", "");
                  if ($placeholder) {
                    $placeholder.remove();
                  }

                  deferred.resolve();
                },
              }
            );

            return deferred.promise();
          };

          self.updateScrollTopDependentControlsPositioningClasses = function () {
            var contentTop = $element[0].getBoundingClientRect().top;
            var contentBottom = $element[0].getBoundingClientRect().bottom;
            var controlsRect = self.$controls[0].getBoundingClientRect();
            var controlsHeight = controlsRect.bottom - controlsRect.top;
            var controlsBottomIfFixed = self.controlsDistanceFromPageTop + controlsHeight;
            var viewportTop = 0;

            var contentTopIsNoLongerVisible = contentTop < viewportTop + self.navBarHeight;
            var controlsStillWellAboveContentBottom =
              controlsBottomIfFixed < contentBottom - self.controlsDistanceFromContentBottom - self.navBarHeight;

            self.$controls.toggleClass("is-locked-to-content-bottom", !controlsStillWellAboveContentBottom);
            self.$controls.toggleClass("is-fixed", contentTopIsNoLongerVisible && controlsStillWellAboveContentBottom);

            // adjust top if fixed based on header
            var topStyle = self.$controls.hasClass("is-fixed")
              ? self.controlsDistanceFromPageTop + self.navBarHeight + "px"
              : self.$controls.hasClass("is-locked-to-content-bottom")
              ? "auto"
              : "";

            self.$controls.css("top", topStyle);
          };

          self.startUpdatingControlsPositioningOnScroll = function () {
            self.updateScrollTopDependentControlsPositioningClasses(); // update once right now
            // Attach an event handler to the document
            addEventListener("scroll", self.updateScrollTopDependentControlsPositioningClasses);
            addEventListener("scroll", self.updateScrollTopDependentControlsPositioningClasses);
          };

          self.stopUpdatingControlsPositioningOnScroll = function () {
            // Remove an event handler to the document
            removeEventListener("scroll", self.updateScrollTopDependentControlsPositioningClasses);
            self.$controls.removeClass("is-locked-to-content-bottom").removeClass("is-fixed");
          };

          self.isOnScreen = function ($el) {
            if (!$el.length) {
              return false;
            }

            var rect = $el[0].getBoundingClientRect();
            return (rect.bottom <= innerHeight && rect.bottom >= 0) || (rect.top <= innerHeight && rect.top >= 0);
          };

          self.animateContentFade = function (fadeInOrFadeOut) {
            var deferred = $.Deferred();

            var isFadingIn = fadeInOrFadeOut === "fade-in";

            var $overlay = angular.element('<div class="ty-fancy-accordion-overlay"></div>');
            $element.append($overlay);

            var opacityStart, opacityEnd, opacityDuration, opacityEasing;

            var opacityDelay = isFadingIn ? self.totalDuration - self.baseDuration - OPACITY_DELAY_FUDGE_MS : 0; // 100ms fudge for setTimeout inaccuracy

            if (isFadingIn) {
              opacityStart = 1;
              opacityEnd = 0;
              opacityDuration = self.baseDuration;
              opacityEasing = "easeInOutExpo";
            } else {
              opacityStart = 0;
              opacityEnd = 1;
              opacityDuration = self.baseDuration;
              opacityEasing = "easeInOutExpo";
            }

            $overlay.css("opacity", opacityStart);

            setTimeout(function () {
              $overlay.animate(
                {
                  opacity: opacityEnd,
                },
                opacityDuration,
                opacityEasing,
                function () {
                  $overlay.remove();
                  deferred.resolve();
                }
              );
            }, opacityDelay);

            return deferred.promise();
          };

          self.init();
        },
      };
    },
  ]);
})(
  window.angular,
  window.getComputedStyle,
  window.innerHeight,
  window.innerWidth,
  window.addEventListener,
  window.removeEventListener,
  window.ToyotaConsts
);
